import React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import IconButton from '@mui/material/IconButton';

import Divider from '@mui/material/Divider';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import CloseIcon from '@mui/icons-material/Close';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { closeMenu ,openSurveySearchDialog, openVectorLayerControl, openRasterLayerControl} from '../../redux/actions/controlbuttonaction'
import { sidebarwith } from './const';
import { bgColors } from '../utils/bgColor';
import { iconStyle, dividerStyle } from './styleConst';
import { useDispatch } from 'react-redux';
import { SerchVillage } from '../FormComopents';
import TravelExploreSharpIcon from '@mui/icons-material/TravelExploreSharp';
import Avatar from '@mui/material/Avatar';
import { AppBar } from '@mui/material';
import MapCustomization from '../FormComopents/Form/MapCustomization';
import {setUserData} from "../../redux/actions/authaction"
// import { openVectorLayerControl } from '../../redux/actions/controlbuttonaction';
// const UpdateToke = () => {
//   const token = useToken()
//   return token
// }

function refreshPage() {
  window.location.reload(false);
}

const drawerWidth = sidebarwith;
const SideBarMenu=(Props) =>{
  const {menuOpen} = Props
  const dispatch = useDispatch()
  const logout = (e) => {
    e.preventDefault()
    sessionStorage.removeItem('user');
    dispatch(setUserData({}))
    refreshPage()
  };
 
  return (
    <Box sx={{ display: 'flex'}} style={{
      backgroundColor:bgColors.sidebar_grey,
      position:'relative'
      }}>
      <Drawer
        sx={
            {
              // width: drawerWidth,
              flexShrink: 0,
              '& .MuiDrawer-paper': {
                width: drawerWidth,
                // marginTop:'2rem',
                // marginLeft:'1rem', 
                // maxHeight:'600px',
                boxSizing: 'border-box',
                backgroundColor:bgColors.sidpanel_grey,
                color:bgColors.grey_300,
                overflow:'auto',
                borderRadius:3,        
              }            
            }
          }
        variant="persistent"
        anchor="left"
        open={menuOpen}
      >
        <AppBar sx = {{width:sidebarwith, left:0,
          backgroundColor:bgColors.sidebar_grey
        }}>
        <Grid container
          padding={2}
        >
          <Grid item xs={2} 
          container
          direction="row"
          alignItems="center"
          justifyContent="center"
          >
          <TravelExploreSharpIcon style={{color: bgColors.blue_button_background, 
              marginRight:'0.5Rem',
              height:'30px',
              width: '30px',
              }}/> 
          </Grid>
          <Grid item xs={8} 
           container
           direction="row"
           alignItems="center"
           justifyContent="center"
          
          >
          <Typography variant="h5"  gutterBottom 
              style={{
              color:bgColors.grey_400, 
              fontWeight: "bold"
              }} display="inline">
                GlobeZoom
            </Typography>
          </Grid>   
          {/* <Divider orientation='vertical' style={dividerStyle}/> */}
          <Grid item xs={2}
           container
           direction="row"
           alignItems="center"
           justifyContent="center"
          
          
          >
          <IconButton   onClick={() => dispatch(closeMenu)}  style={iconStyle} >
              <CloseIcon fontSize ='Large' style={{ height:'30px',
              width: '30px', color:bgColors.grey_300}}/>
            </IconButton> 
          </Grid>   
        </Grid>
        
        <Grid container 
            spacing={2}
            direction = "row"
            >
          </Grid>
          <Grid item
            container
            direction="row"
            alignItems="center"
            justifyContent="center"
           >
          <Avatar
           alt="Remy Sharp" 
           src="../AnaishaAkj.png"
           sx={{ width: 40, height: 40 }}
           // size='small'
           // onClick={() => dispatch(openMenu)}
           style = {{marginTop:'0.25rem', marginRight:'0.25rem'}}
          >
          </Avatar>
          </Grid>
          <Grid
            container
            direction="row"
            alignItems="center"
            justifyContent="center"
          >
          <Button sx = {{color:bgColors.blue_button_background}}
            onClick = {logout}
          >
              <Typography variant="body2" gutterBottom>
                Sign out
              </Typography>
            </Button>
          </Grid>
          
        <Divider style={dividerStyle}/>
        <Divider style={dividerStyle}/>
        <List> 
        <Button key = {'open_menu_button'} size='small' sx={{marginRight:'0.5rem',
              color:bgColors.grey_300
                }} 
              onClick={()=> dispatch(openSurveySearchDialog)} 
            >
            Go to surveysearch
        <KeyboardDoubleArrowRightIcon sx={{ mr: 1}} />
        </Button>
         </List>
         <List>
         <SerchVillage/>
         </List>
       
        </AppBar>
         <Box style={{position:'absolute', marginTop:'70%'}}> 
        <MapCustomization/>
      </Box>
      </Drawer>

    </Box>
  );
}
export default SideBarMenu
